import React, { useEffect, useState, useCallback } from 'react';
import { VehicleView } from './VehicleGapDetection.types';

interface HatchbackSVGProps {
  view: VehicleView;
  className?: string;
  onLoad?: () => void;
}

/**
 * Komponent SVG sylwetki hatchbacka dla różnych widoków
 * Używa dynamicznego importu jak w SVGIcon
 */
export const HatchbackSVG: React.FC<HatchbackSVGProps> = ({ view, className = '', onLoad }) => {
  const [IconComponent, setIconComponent] = useState<React.FC<
    React.SVGProps<SVGSVGElement>
  > | null>(null);

  const getSvgName = useCallback(() => {
    switch (view) {
      case 'left':
        return 'hatchback-strona-lewa';
      case 'top':
        return 'hatchback-gora';
      case 'right':
        return 'hatchback-strona-prawa';
    }
  }, [view]);

  const importIcon = useCallback(async () => {
    try {
      const svgName = getSvgName();
      /* @vite-ignore */
      const imported = await import(`./svg/${svgName}.svg`);
      setIconComponent(() => imported.ReactComponent);
    } catch (error) {
      console.error(`HatchbackSVG: Błąd podczas importowania ${view}:`, error);
    }
  }, [view, getSvgName]);

  useEffect(() => {
    importIcon();
  }, [importIcon]);

  useEffect(() => {
    if (IconComponent && onLoad) {
      onLoad();
    }
  }, [IconComponent, onLoad]);

  if (!IconComponent) {
    return <div className={className} />;
  }

  return <IconComponent className={className} />;
};
